import { z } from "zod";

export const equipmentTypeOptions = ["core", "consumable", "accessory"] as const;

export const addEquipmentSchema = z.object({
	label: z
		.string()
		.min(1, "Equipment label is required.")
		.max(500, "Equipment label must be less than 500 characters.")
		.refine(
			value => /^[a-zA-Z0-9\s,()/&:.\-"'']+$/.test(value),
			"Only letters, numbers, spaces, and whitelisted special characters (. , ( ) \" ' & - / :) are allowed.",
		),
	equipmentType: z.enum(equipmentTypeOptions, {
		required_error: "Equipment type is required.",
		invalid_type_error: "Please select a valid equipment type.",
	}),
	description: z.string().optional(),
});
